import { ValidationIndicatorState } from '@zorro/types';

import { callEndpoint } from './callEndpoint';

export const validateAddress = async (
  address: string | undefined,
  setIsAddressValid?: (validityState: ValidationIndicatorState) => void
) => {
  if (!address) {
    return { isValidAddress: false };
  }
  setIsAddressValid?.(ValidationIndicatorState.validating);
  const { isValidAddress, isPoBox, possibleFipsCodes, formattedAddress } =
    await callEndpoint({
      method: 'addressControllerValidateAddress',
      params: [{ address }],
    });
  setIsAddressValid?.(
    isValidAddress
      ? ValidationIndicatorState.valid
      : ValidationIndicatorState.invalid
  );
  return { isValidAddress, isPoBox, possibleFipsCodes, formattedAddress };
};
